import * as React from 'react';
import PropTypes from 'prop-types';

const CloseButton = ({ color = 'rgb(133, 137, 145)', ...rest }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M15.2905 13.8693C15.681 14.2598 15.6766 14.8975 15.286 15.288C14.8955 15.6785 14.2579 15.683 13.8674 15.2925L7.99767 9.42277L2.12797 15.2925C1.73744 15.683 1.09981 15.6785 0.709285 15.288C0.318761 14.8975 0.314291 14.2598 0.704815 13.8693L6.57451 7.99962L0.70473 2.12984C0.314206 1.73931 0.318676 1.10168 0.7092 0.711153C1.09972 0.320629 1.73736 0.31616 2.12788 0.706684L7.99767 6.57647L13.8674 0.706684C14.258 0.31616 14.8956 0.320629 15.2861 0.711153C15.6767 1.10168 15.6811 1.73931 15.2906 2.12984L9.42082 7.99962L15.2905 13.8693Z"
      fill={color}
    />
  </svg>
);
export default CloseButton;

CloseButton.propTypes = {
  color: PropTypes.string,
};
